import Roles from "../config/roles";
import { ORDER_STATE, ORDER_STATE_N2 } from "../config/constants";


class OrderStates {

    // Etiquetas en el orden del flujo de Nave 1 (no por código: los códigos no siguen el flujo)
    static states = ["Sin preparar", "En preparación", "Preparado", "En revisión", "Finalizado"];

    // Etiqueta por código de Nave 1
    static ESTADOS_MAP = {
        [ORDER_STATE.SIN_PREPARAR]: 'Sin preparar',
        [ORDER_STATE.EN_PREPARACION]: 'En preparación',
        [ORDER_STATE.PREPARADO]: 'Preparado',
        [ORDER_STATE.EN_REVISION]: 'En revisión',
        [ORDER_STATE.FINALIZADO]: 'Finalizado'
    };

    // Etiqueta por código de Nave 2 ('4' solo aparece en registros antiguos)
    static ESTADOS_MAP_N2 = {
        [ORDER_STATE_N2.SIN_PREPARAR]: 'Sin preparar',
        [ORDER_STATE_N2.EN_PREPARACION]: 'En preparación',
        [ORDER_STATE_N2.PREPARADO]: 'Preparado',
        '4': 'En revisión'
    };

    static FLUJO_N1 = [
        ORDER_STATE.SIN_PREPARAR,
        ORDER_STATE.EN_PREPARACION,
        ORDER_STATE.PREPARADO,
        ORDER_STATE.EN_REVISION,
        ORDER_STATE.FINALIZADO
    ];

    static FLUJO_N2 = [ORDER_STATE_N2.SIN_PREPARAR, ORDER_STATE_N2.EN_PREPARACION, ORDER_STATE_N2.PREPARADO];

    static toOption(codigo, mapa) {
        return {label: mapa[codigo], value: Number(codigo)};
    }

    /**
     * Opciones de Nave 1 en el orden del flujo (value numérico)
     */
    static getStatesJson() {
        return this.FLUJO_N1.map((codigo) => this.toOption(codigo, this.ESTADOS_MAP));
    }

    /**
     * Estados que admite Nave 2: termina en PREPARADO, sin EN_REVISION ni FINALIZADO
     * @returns {Array<{label: string, value: number}>} Opciones para el selector de Nave 2
     */
    static getStatesJsonN2() {
        return this.FLUJO_N2.map((codigo) => this.toOption(codigo, this.ESTADOS_MAP_N2));
    }

    static getStatesJsonRole(roles) {

        if (roles.includes(Roles.ADMIN.role)) {
            return this.getStatesJson();
        }

        if (roles.includes(Roles.ALMACEN.role)) {
            return [ORDER_STATE.EN_PREPARACION, ORDER_STATE.PREPARADO]
                .map((codigo) => this.toOption(codigo, this.ESTADOS_MAP));
        }

        return [this.toOption(ORDER_STATE.EN_PREPARACION, this.ESTADOS_MAP)];
    }

    // Un estado desconocido cae al valor crudo en vez de a undefined: hay
    // consumidores que encadenan sobre el resultado (Orders.js hace .toLowerCase())
    // y un undefined ahí es un TypeError, no una etiqueta vacía.
    static getState(state) {
        return this.ESTADOS_MAP[String(state ?? "")] ?? String(state ?? "");
    }

    /**
     * Etiqueta de un código de Nave 2 ('3' es PREPARADO, no FINALIZADO)
     */
    static getStateN2(state) {
        return this.ESTADOS_MAP_N2[String(state ?? "")] ?? String(state ?? "");
    }
}

export default OrderStates;
